<template>
    <div class="dashboard__view mb-5">
      <div class="page">
      <div class="relative">
        <div class="text-light">
          <p>
            Filter Blacklists by :
            <span @click="openFilters = !openFilters"
              >All Blacklists
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="openFilters ? '' : 'rotate'"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </p>
        </div>
        <div class="filter-dropdown" v-if="openFilters">
          <div class="filter-title">ID</div>
          <div class="form__item">
            <input
              class="form__input"
              type="text"
              v-model="filterList.id_number"
            />
          </div>
          <div class="filter-title">Name</div>
          <div class="form__item">
            <input
              class="form__input"
              type="text"
              v-model="filterList.name"
            />
          </div>
          <div class="">
            <p class="filter-title">TYPE</p>
            <div
              v-for="status in typeGroup"
              class="status-element"
              :key="status.id"
              @click="() => (filterList.type = status.id)"
            >
              <p v-if="status.id === filterList.type">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#e00b5b" />
                  <path
                    d="M11 6L6.875 10L5 8.18182"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
              <p v-else>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="7.5" stroke="#979797" />
                </svg>
              </p>
              <p class="filter-title">{{ status.name }}</p>
            </div>
          </div>
          <div>
            <div>
              <div class="mt-4">
                <p class="filter-title">Start Date</p>
                <input
                  placeholder="dd/mm/yyyy"
                  class="date margin-right"
                  type="date"
                  id="_date"
                  v-model="filterList.from"
                />
              </div>
              <div class="end-date mt-4">
                <p class="filter-title">End Date</p>
                <input
                  placeholder="dd/mm/yyyy"
                  class="date"
                  type="date"
                  id="date"
                  v-model="filterList.to"
                />
              </div>
            </div>
          </div>
          <div class="button-group">
            <button
              class="btn woven-border-only woven-red"
              @click="clearFilter"
            >
              Reset Filter
            </button>
            <button class="btn woven-color" @click="triggerFilter">
              <p>Filter</p>
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>
      <div style="width: 100%; display: flex; justify-content: flex-end; align-items: center;">
        <div class="items-flex">
              <button class="btn woven-color pt-3 pb-4" @click.prevent="gotoUpload">Create</button>
            </div>
      </div>
        <Tab :tabs="tabs" />
      <div class="list">
        <div class="tab__content">
          <div class="tab__content__top">
            <div class="tab__content__top__left">
              {{ pageInfo.total }} blacklists
              <div class="tab__content__top__right">
                <div class="tab__content__top__item">
                  <button
                    @click="clearFilter"
                    class="btn btn--sm btn--default"
                    v-if="openFilters"
                  >
                    Clear Filter
                  </button>
                </div>
                <div class="tab__content__top__item">
                  <button
                    @click="openFilters = true"
                    class="btn btn--sm btn--default"
                  >
                    Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
              class="tab__content__top"
              style="padding-top: 0"
              v-if="openFilters"
            >
              <div class="tab__content__top__left">.</div>
              </div>
          <EmptyState v-if="emptyState" type="not-found" icon="transaction" />
  
          <div v-else>
            <!-- Loader -->
            <div class="loader" v-if="loading">
              <span aria-hidden="true" class="spinner-border"></span>
            </div>
            <table class="table card-table" v-else>
              <thead>
                <tr>
                  <th>ID Number</th>
                  <th>name</th>
                  <th>type</th>
                  <th>source</th>
                  <th>class</th>
                  <th>added by</th>
                  <th style="text-align: left;">reason</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="item.id"
                  v-for="item in transactionList"
                >
                <td>{{ item.id_number}}</td>
                <td class="account-details">
                  {{ item.name || "Not Available" }}
                </td>
                <td>{{ item.type ? item.type.replace(/_/g, " ") : "Not Available" }}</td>
                <td>{{ item.source ? item.source : "Not Available" }}</td>
                <td>{{ item.class ? (item.class.substring(0,1).toUpperCase() + item.class.substring(1).toLowerCase()) : "Not Available" }}</td>
                <td>{{ item.addedBy ? item.addedBy : "Not Available" }}</td>
                <td style="text-align: left;">{{ item.reason ? item.reason : "Not Available" }}</td>
                <td class="act">
                  <b-dropdown
                    variant="link"
                    right
                    size="sm"
                    no-caret
                    toggle-class="blacklist-pending-actions-toggle"
                    :toggle-attrs="{ 'aria-label': 'Row actions' }"
                  >
                    <template #button-content>
                      <svg
                        width="4"
                        height="16"
                        viewBox="0 0 4 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <circle cx="2" cy="2" r="2" fill="#919EAB" fill-opacity="0.6" />
                        <circle cx="2" cy="8" r="2" fill="#919EAB" fill-opacity="0.6" />
                        <circle cx="2" cy="14" r="2" fill="#919EAB" fill-opacity="0.6" />
                      </svg>
                    </template>
                    <div
                      class="act__item dropdown-item-list"
                      @click.prevent="openBlacklistConfirm('approve', item)"
                    >
                      <span class="green-status">Approve</span>
                    </div>
                    <div
                      class="act__item dropdown-item-list"
                      @click.prevent="openBlacklistConfirm('decline', item)"
                    >
                      <span class="red-status">Decline</span>
                    </div>
                  </b-dropdown>
                </td>
                </tr>
              </tbody>
            </table>
            <div
              class="table__details"
              v-if="loading !== true && emptyState !== true"
            >
              <div class="table__details__left">
                <span class="text-muted" v-if="pageInfo.total"
                  >Page {{ pageInfo.current_page }} of
                  {{ pageInfo.total_pages }}</span
                >
              </div>
              <div class="table__details__right">
                <Pagination :numberOfPages="pageInfo.total_pages" />
              </div>
              <div class="table__details__right"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="blacklistActionConfirm"
        class="blacklist-confirm-overlay"
        @click.self="closeBlacklistConfirm"
      >
        <div class="blacklist-confirm-dialog" role="dialog" aria-modal="true">
          <div class="blacklist-confirm-dialog__body">
            <h2 class="blacklist-confirm-dialog__title">{{ blacklistConfirmTitle }}</h2>
            <p v-if="blacklistActionConfirm.item" class="blacklist-confirm-dialog__text">
              <span v-if="blacklistActionConfirm.action === 'approve'">
                Approve the pending blacklist for
                <strong>{{ blacklistActionConfirm.item.id_number }}</strong>
                <span v-if="blacklistActionConfirm.item.name"> ({{ blacklistActionConfirm.item.name }})</span>?
              </span>
              <span v-else>
                Decline the pending blacklist for
                <strong>{{ blacklistActionConfirm.item.id_number }}</strong>
                <span v-if="blacklistActionConfirm.item.name"> ({{ blacklistActionConfirm.item.name }})</span>?
                This action cannot be undone.
              </span>
            </p>
            <div class="blacklist-confirm-dialog__actions">
              <button type="button" class="confirm_btn" @click="closeBlacklistConfirm">
                Cancel
              </button>
              <button type="button" class="reverse_btn" @click="submitBlacklistConfirm">
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import AccountStatement from "@/components/accountStatementModal.vue";
  import { formatAmount } from "@/lib/formatAmount.js";
  import Pagination from "@/components/pagination.vue";
  import Tab from "@/components/tab.vue"

  export default {
    metaInfo: {
      title: "Blacklists",
    },
    components: {
      AccountStatement,
      Pagination,
      Tab
    },
    data() {
      return {
        merchantList: {},
        merchantBalance: 0,
        loading: false,
        pageInfo: "",
        transactionList: "",
        emptyState: false,
      openFilters: false,
      typeGroup: [
        {
          id: "bvn",
          name: "BVN",
        },
        {
          id: "nin",
          name: "NIN",
        },
        {
          id: "account_number",
          name: "Account Number",
        },
      ],
      filterList: {
        id_number: this.$route.query.unique_reference
          ? this.$route.query.unique_reference
          : "",
        name: this.$route.query.account_reference
          ? this.$route.query.account_reference
          : "",
        type: this.$route.query.type ? this.$route.query.type : "",
        to: this.$route.query.to ? this.$route.query.to : "",
        from: this.$route.query.from ? this.$route.query.from : "",
      },
      openFilters: false,
      tabs: [
        {
          url: `/dashboard/blacklists/pending`,
          name: "Pending",
        },
        {
          url: `/dashboard/blacklists/approved`,
          name: "Approved",
        }
      ],
      blacklistActionConfirm: null,
      };
    },

    computed: {
      blacklistConfirmTitle() {
        if (!this.blacklistActionConfirm) return "";
        return this.blacklistActionConfirm.action === "approve"
          ? "Confirm approval"
          : "Confirm decline";
      },
    },
  
    methods: {
      formatAmount,
      clearFilter() {
        this.filterList = {
          id_number: "",
          name: "",
          type: "",
          to: "",
          from: "",
        };
        this.$router.push({ path: "/dashboard/blacklists/pending", query: { page: "1" } });
      },
      moment: window.moment,
      triggerFilter() {
      let queryObject = {};
      if (this.filterList.id_number) {
        queryObject.id_number = this.filterList.id_number.trim();
      }
      if (this.filterList.name) {
        queryObject.name = this.filterList.name.trim();
      }
      if (this.filterList.type) {
        queryObject.type = this.filterList.type;
      }
      if (this.filterList.to) {
        queryObject.to = moment(this.filterList.to).format("YYYY-MM-DD");
      }
      if (this.filterList.from) {
        queryObject.from = moment(this.filterList.from).format("YYYY-MM-DD");
      }

      queryObject.page = 1;
      //Route to page with query
      this.$router.push({
        path: "/dashboard/blacklists/pending",
        query: queryObject,
      });

      //Close filter modal
      this.openFilters = !this.openFilters;
    },
    returnQuery() {
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        if (name == "class" || name == "type") {
          generatedQuery += `${name}=${value.toUpperCase()}`;
        } else {
          generatedQuery += `${name}=${value}`;
        }
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }
      return generatedQuery;
    },
      fetchTransactions() {
        let generatedQuery = this.returnQuery();
        this.loading = true;
        const url = `blacklists/pending?${generatedQuery}&limit=10`;
        this.$http
          .get(url)
          .then((response) => {
            if (response.body.data.blacklists.length > 0) {
              this.transactionList = response.body.data.blacklists;
              this.pageInfo = response.body.data.page_info;
              this.emptyState = false;
              this.loading = false;
            } else {
              this.emptyState = true;
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      gotoUpload() {
      this.$router.push('/dashboard/blacklists/upload');
    },
      notifyPendingSuccess(text) {
        this.$notify({ group: "notifications-default", type: "success text-white", title: "Success", text });
        this.fetchTransactions();
      },
      handleBlacklistErr(error) {
        this.loading = false;
        const text = (error.body && error.body.message) || "An error occured.";
        this.$notify({ group: "notifications-default", type: "error text-white", title: "Error", text });
      },
      openBlacklistConfirm(action, item) {
        this.blacklistActionConfirm = { action, item };
      },
      closeBlacklistConfirm() {
        this.blacklistActionConfirm = null;
      },
      submitBlacklistConfirm() {
        const ctx = this.blacklistActionConfirm;
        if (!ctx) return;
        const { action, item } = ctx;
        this.closeBlacklistConfirm();
        if (action === "approve") this.runApproveBlacklist(item);
        else this.runDeclineBlacklist(item);
      },
      runApproveBlacklist(item) {
        this.loading = true;
        this.$http.put(`blacklists/${item.id}/approve`).then(() => this.notifyPendingSuccess("Blacklist approved")).catch(this.handleBlacklistErr);
      },
      runDeclineBlacklist(item) {
        this.loading = true;
        this.$http.put(`blacklists/${item.id}/decline`).then(() => this.notifyPendingSuccess("Blacklist declined")).catch(this.handleBlacklistErr);
      },
    },
    mounted() {
      this.fetchTransactions();
    },
    watch: {
        '$route.query'() {
            this.fetchTransactions();
        }
    }
  };
  </script>
  <style>
  .items-flex{
    width: fit-content !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    margin-bottom: 1rem;
  }
  .items-flex > button{
    height: 40px;
    color: #e00b5b !important;
    border-radius: 4px !important;
    background-color: white !important;
    border: 1px solid #e00b5b !important;
  }
  .dropdown-item-list{
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .tab__content__top__left{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .green-status {
    color: #00b87c !important;
  }
  .red-status {
    color: #e00b5b !important;
  }
  .other-status{
    color: #FFBF00 !important;
  }
  .account-details{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
  .download-text{
    font-size: 12px;
    color: #A0A3BD;
    cursor: pointer;
  }
  .blacklist-pending-actions-toggle.btn,
  .blacklist-pending-actions-toggle.btn:hover,
  .blacklist-pending-actions-toggle.btn:focus,
  .blacklist-pending-actions-toggle.btn:active,
  .blacklist-pending-actions-toggle.btn.show {
    text-decoration: none !important;
    padding: 4px 8px !important;
    box-shadow: none !important;
    background: transparent !important;
    background-color: transparent !important;
    color: #616e7c !important;
    border: none !important;
    border-color: transparent !important;
  }
  .blacklist-pending-actions-toggle::after {
    display: none !important;
  }
  </style>
<style lang="scss" scoped>
// filter styles start
.relative {
  position: relative;
}
.end-date {
  margin-top: 15px;
}
.rotate {
  transform: rotate(180deg);
}
.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;

  svg {
    margin-right: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}
.woven-strip {
  position: absolute;
  left: 0;
}
.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  height: 40px;
  svg {
    margin-left: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #e00b5b;
  }
}
.filter-dropdown {
  background: #fff;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  left: 0;
  min-width: 300px;
  .form__item {
    margin-bottom: 16px;
  }
}
.woven-red {
  color: #e00b5b;
}
.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);
  p {
    width: 100%;
  }
  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}
.date-group {
  display: flex;
}
.margin-right {
  margin-right: 16px;
}
.date {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px;
  width: 100%;
}
.status-element {
  display: flex;
  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}
.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  span {
    color: #e00b5b;
    cursor: pointer;
  }
}
.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  // margin-bottom: 16px;
  margin: 5px 0;
}
// filter styles end
.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    color: #e00b5b;
    cursor: pointer;
  }
}

.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
.btn-filter {
  height: 50px;
  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
.no-bg {
  background: none !important;
}

.modal-body {
  justify-content: center !important;
  h2 {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;
  }

  p {
    margin-bottom: 31px;
    color: #616e7c;
  }

  svg {
    margin-bottom: 12px;
  }

  textarea {
    resize: none;
    height: 4rem;
  }

  .boxed {
    width: 60%;
    margin: 0.5rem auto 1.5rem;
    .form__flex__item,
    button {
      margin-left: 0;
      width: 100%;
    }

    .details__card__item {
      padding: 0 0 24px;
      border: none;
    }
  }
}
.confirm_btn {
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e00b5b;
  box-sizing: border-box;
  color: #e00b5b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  width: fit-content;
  padding-left: 16px;
  padding-right: 16px;
  text-wrap: nowrap;
}
.reverse_btn {
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  background-color: #e00b5b;
  border-radius: 6px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  width: fit-content;
  padding-left: 16px;
  padding-right: 16px;
  text-wrap: nowrap;
}
.tab__content__top__left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.green-status {
  color: #00b87c;
}
.red-status {
  color: #e00b5b;
}
.other-status{
  color: #FFBF00;
}
.actions{
  display: flex;
  align-items: center;
  gap: 16px;
  width: fit-content;
}
.reverse-icon{
  height: 40px;
  width: 40px;
  color: #E00B5B;
  cursor: pointer;
}
.blacklist-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(20, 20, 43, 0.4);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}
.blacklist-confirm-dialog {
  position: relative;
  background: #fff;
  border-radius: 12px;
  max-width: 440px;
  width: 100%;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.blacklist-confirm-dialog__body {
  padding: 22px 26px 24px;
}
.blacklist-confirm-dialog__title {
  margin: 0 0 12px;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.35;
  color: #14142b;
  letter-spacing: -0.02em;
}
.blacklist-confirm-dialog__text {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: #616e7c;
}
.blacklist-confirm-dialog__text strong {
  color: #14142b;
  font-weight: 600;
}
.blacklist-confirm-dialog__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}
.blacklist-confirm-dialog__actions .confirm_btn,
.blacklist-confirm-dialog__actions .reverse_btn {
  min-width: 108px;
}
</style>